var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckmarkSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#16A66C",
  fillRule: "evenodd",
  d: "M19.06 2.52a1.126 1.126 0 0 1-.696 2.141c-5.712-1.856-11.847 1.27-13.703 6.982s1.27 11.847 6.982 13.703 11.847-1.27 13.703-6.982c.645-1.985.703-4.067.198-6.044a1.126 1.126 0 0 1 2.18-.557c.61 2.387.54 4.903-.238 7.296-2.24 6.894-9.644 10.667-16.538 8.427S.28 17.842 2.52 10.948 12.165.28 19.059 2.52zm7.236 1.2c.452.34.576.953.315 1.436l-.09.14-11.423 15.23a1.125 1.125 0 0 1-1.666.15l-.113-.122-5.077-6.346a1.124 1.124 0 0 1 1.644-1.527l.113.122 4.17 5.212 10.552-14.07a1.126 1.126 0 0 1 1.575-.224z"
})));
export default SvgCheckmarkSuccess;